import { useSearchParams } from 'react-router-dom';

import { Notice } from '../../../common/components/detail/detail';
import PlanMap from './map';
import PlansOverview from './overview';

import '../styles/plans.css';

// La sección de Planeación, suelta y entre proyectos.
//
// Los planes ya existían dentro de la pestaña de cada proyecto, y eso deja una
// pregunta sin responder: *«¿qué hay para revisar hoy?»* — que no es de un
// proyecto, es de todos. Abrir doce proyectos para averiguarlo es el trabajo
// que esta pantalla ahorra.
//
// El listado es el MISMO componente que usa la pestaña, con el filtro de
// proyecto encendido. Una segunda lista se habría ido pareciendo cada vez
// menos a la primera.

// DOS VISTAS DE LO MISMO. La lista responde «qué hay para revisar hoy»; el mapa
// responde «de dónde salió esto»: plan, versión, tiers y tareas en cascada. La
// elección vive en la URL, así que un mapa abierto se puede enlazar.
const VIEWS = [
    { key: '',     label: 'Lista' },
    { key: 'mapa', label: 'Mapa' },
];

export default function PlanningScreen() {
    const [params, setParams] = useSearchParams();
    const view = params.get('view') === 'mapa' ? 'mapa' : '';

    const setView = (next) => {
        const target = new URLSearchParams(params);
        if (next) target.set('view', next);
        else target.delete('view');
        // Lo que era de la otra vista no viaja: la página de la lista y el plan
        // elegido en el mapa no significan nada del otro lado.
        ['page', 'plan'].forEach(key => target.delete(key));
        setParams(target);
    };

    return (
        <section className="plans plans--screen">
            <header className="plans__header">
                <div className="plans__heading">
                    <span className="plans__eyebrow">De acá salen los tiers</span>
                    <h2 className="plans__title">Planeación</h2>
                </div>
            </header>

            <div className="plans__views" role="group" aria-label="Forma de ver la planeación">
                {VIEWS.map(option => (
                    <button
                        key={option.key || 'lista'}
                        type="button"
                        className={`plans__view ${view === option.key ? 'plans__view--active' : ''}`}
                        onClick={() => setView(option.key)}
                        aria-pressed={view === option.key}
                    >
                        {option.label}
                    </button>
                ))}
            </div>

            {/* El recorrido, dicho una vez y arriba: sin esto, «aprobar» se lee
                como un trámite en vez de como la firma que habilita el
                desglose. */}
            <Notice tone="accent">
                Un plan se escribe como <strong>borrador</strong>, se
                {' '}<strong>presenta</strong> a revisión, y se{' '}
                <strong>aprueba</strong>. Un tier solo se crea desde una versión
                aprobada — y queda amarrado a <strong>esa</strong>: aprobar la siguiente no le
                cambia el origen a lo que ya salió de la anterior.
            </Notice>

            {view === 'mapa' ? <PlanMap /> : <PlansOverview />}
        </section>
    );
}
